import { useRef } from "react";
import PropTypes from "prop-types";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "../constants";

const DraggableItem = ({ id, moveItem, children }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: ItemTypes.SCHOOL,
    hover(item) {
      if (!ref.current) {
        return;
      }
      const dragId = item.id;
      const hoverId = id;

      if (dragId === hoverId) {
        return;
      }

      item.hoverId = hoverId;
      moveItem(dragId, hoverId);
    }
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.SCHOOL,
    item: () => {
      return { id };
    },
    end: (item) => {
      const dragId = item.id;
      const hoverId = item.hoverId;

      if (hoverId !== null && hoverId !== undefined && dragId !== hoverId) {
        moveItem(dragId, hoverId, true);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div ref={ref} style={{ opacity }}>
      {children}
    </div>
  );
};

DraggableItem.propTypes = {
  id: PropTypes.string.isRequired,
  moveItem: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default DraggableItem;
